'use es6';

import { useEffect, useState } from 'react';

const useWaitUntilQuerySelector = selector => {
  const [targetElement, setTargetElement] = useState();
  useEffect(() => {
    if (targetElement) return;
    const globalSearch = document.querySelector(selector);

    if (globalSearch) {
      setTargetElement(globalSearch);
      return;
    }

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (!mutation.addedNodes.length) return;

        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (mutation.addedNodes[i] instanceof HTMLElement) {
            const foundElement = mutation.addedNodes[i].querySelector(selector);

            if (foundElement) {
              setTargetElement(foundElement);
              return;
            }
          }
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    }); // eslint-disable-next-line consistent-return

    return () => {
      observer.disconnect();
    };
  }, [selector, targetElement]);
  return targetElement;
};

export default useWaitUntilQuerySelector;